import axios from "axios";

export default function roleDropdown() {
  return new Promise((resolve, reject) =>
    axios
      .get(`/account/system-admin/api/v1/role-dropdown`)
      .then((response) => resolve(response.data))
      .catch((error) => reject(error.message))
  );
}
